<template>
	<div>
		<topback title="Withdraw History" path="back"></topback>
		<div class="deposit-history">
			<md-tab-bar
			v-model="current"
			:items="items"
			@change="onTabChange"
			></md-tab-bar>
			<md-swiper
			ref="swiper"
			:autoplay="0"
			:is-prevent="false"
			:is-loop="false"
			:has-dots="false"
			@before-change="onSwiperChange"
			>
			<md-swiper-item>
				<md-field class="historylist pt-0">
					<md-cell-item title="USDT" brief="2022-11-11 11:11:11" v-for="i in 10" v-bind:key="i">
						<template slot="right">
							<p>1500</p>
							<p>
								<pointtext text="Completed" type="success"></pointtext>
							</p>
						</template>
					</md-cell-item>
				</md-field>
			</md-swiper-item>
			<md-swiper-item>
				<md-scroll-view
					ref="scrollView"
					:scrolling-x="false"
					@refreshing="$_onRefresh"
					>
					<md-scroll-view-refresh
						slot="refresh"
						slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
						:scroll-top="scrollTop"
						:is-refreshing="isRefreshing"
						:is-refresh-active="isRefreshActive"
					></md-scroll-view-refresh>
					<div
						v-for="i in list"
						:key="i"
						class="scroll-view-list"
					>
						<p class="scroll-view-item">{{i}}</p>
					</div>
					</md-scroll-view>
			</md-swiper-item>
			</md-swiper>
		</div>
	</div>
</template>

<script>
import topback from '@/components/topback'
import pointtext from '@/components/pointtext'

export default {
	name: 'withdrawhistory',
	components: {
		[topback.name]: topback,
		[pointtext.name]: pointtext
	},

	data() {
		return {
			current: 0,
      		items: [{name: 0, label: 'USDT'}, {name: 1, label: 'INR'}],
			list: 5,
		}
	},
	mounted() {
		window.ScrollViewTrigger1 = () => {
		this.$refs.scrollView.triggerRefresh()
		}
	},
	methods: {
		onSwiperChange(from, to) {
			this.current = to
		},
		onTabChange(item, index) {
			this.$refs.swiper.goto(index)
		},
		$_onRefresh() {
		// async data
			setTimeout(() => {
				this.list += 5
				this.$refs.scrollView.finishRefresh()
			}, 2000)
		},
		contact_service() {
			alert("contact_service");
		}
	}
}

</script>
<style scoped>
.deposit-history {
	margin-top: 0.9rem;
}
.deposit-history .md-swiper {
  background: #FFF;
}
.deposit-history .md-swiper .md-swiper-item {
  padding: 20px;
  box-sizing: border-box;
  font-size: 24px;
  line-height: 1.5;
  color: #666;
}
.historylist >>> .md-cell-item-right {
	display: block;
    color: #000000;
    font-size: 0.28rem;
	text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/my/withdrawhistory.vue